import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import axios from 'axios';


function TermsAndConditions() {
  const navigate = useNavigate()
  const [terms, setTerms] = useState('')

  // const goToHomepage = () => {
  //   navigate('/', {replace: true})
  // }

  useEffect(() => {
    const getTerms = async () => {
        const resp = await axios.get(process.env.REACT_APP_API_URL + 'terms')
        setTerms(resp?.data?.terms ? resp.data.terms : '')
      }

      getTerms()
  }, [])

  return (
    <div className="doc">
      <div style={{ whiteSpace: 'pre-wrap' }}>
        {terms}
      </div>
    </div>
  );
}

export default TermsAndConditions
